// ==============================|| OVERRIDES - DIALOG ||============================== //

export default function Dialog() {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          '@media (max-width: 600px)': {
            margin: '12px !important',
            width: 'calc(100% - 24px) !important',
            maxWidth: 'calc(100% - 24px) !important',
            maxHeight: 'calc(100% - 24px) !important',
            borderRadius: '12px !important'
          }
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          '@media (max-width: 600px)': {
            padding: '16px !important'
          }
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          '@media (max-width: 600px)': {
            padding: '12px 16px !important',
            flexWrap: 'wrap',
            gap: '8px'
          }
        }
      }
    }
  };
}
